import { render, staticRenderFns } from "./CreateCardBtn.vue?vue&type=template&id=7e6d9f8a&scoped=true&"
import script from "./CreateCardBtn.vue?vue&type=script&lang=js&"
export * from "./CreateCardBtn.vue?vue&type=script&lang=js&"
import style0 from "./CreateCardBtn.vue?vue&type=style&index=0&id=7e6d9f8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6d9f8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e6d9f8a')) {
      api.createRecord('7e6d9f8a', component.options)
    } else {
      api.reload('7e6d9f8a', component.options)
    }
    module.hot.accept("./CreateCardBtn.vue?vue&type=template&id=7e6d9f8a&scoped=true&", function () {
      api.rerender('7e6d9f8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/PostForm/CreateCardBtn.vue"
export default component.exports